// extracted by mini-css-extract-plugin
export var pillTrigger = "_5x-0";